function hashHue(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h % 360;
}

export default function MonoAvatar({ name, size = 36, online = false }) {
  const hue = hashHue(name);
  const initials = name
    .split(/\s+/)
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <div style={{ position: 'relative', flexShrink: 0 }}>
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          background: `linear-gradient(135deg, oklch(0.5 0.18 ${hue}), oklch(0.6 0.22 ${(hue + 50) % 360}))`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: size * 0.36,
          fontWeight: 700,
          color: 'rgba(255,255,255,0.95)',
          letterSpacing: '-0.02em',
          boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.18)',
        }}
      >
        {initials}
      </div>
      {online && (
        <span
          style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: 10,
            height: 10,
            borderRadius: '50%',
            background: '#22c55e',
            border: '2px solid #1a0e22',
            boxShadow: '0 0 6px rgba(34, 197, 94, 0.6)',
          }}
        />
      )}
    </div>
  );
}
